<template>
  <div id="app">
    <page-loader :show="loading" :text="loadingText"></page-loader>
    <div class="main">
      <router-view></router-view>
    </div>
    <page-footer />
  </div>
</template>

<script>
import PageFooter from '@/components/page-footer/PageFooter';
import { mapState } from 'vuex';

export default {
  name: 'App',
  async created() {
    this.$store.dispatch('storage/initialiseState');
    this.$store.dispatch('page_loader/start', 0);
    await this.$store.dispatch('token/getToken');
    this.$store.dispatch('page_loader/stop');
    this.$store.dispatch('app_settings/setReferences');

    setInterval(() => this.$store.dispatch('token/getToken'), 10000);
  },
  computed: {
    ...mapState({
      loading: ({ page_loader }) => page_loader.show,
      loadingText: ({ page_loader }) => page_loader.text
    })
  },
  components: {
    PageFooter
  }
};
</script>

<style lang="scss" src="../scss/main.scss"></style>
